var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.75,
    height: 25.75,
    viewBox: "0 0 25.75 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-first-5181176",
    d: "M141.856,58.976V53.639H136.52l-3.77-3.77-3.77,3.77h-5.336v5.336l-3.77,3.77,3.77,3.77v1.43H125.6V65.7l-2.967-2.957,2.967-2.957V55.6h4.19l2.957-2.967,2.957,2.967h4.19v4.19l2.967,2.957L139.9,65.7v4.19h-4.19l-2.957,2.967-2.957-2.967h-6.149v1.958h5.336l3.77,3.77,3.77-3.77h5.336V66.515l3.77-3.77Zm-8.126,7.6h-1.958V60.562l-.91.5-.94-1.713,3.809-2.085v9.311Z",
    transform: "translate(-119.875 -49.87)",
    fill: "#ffba00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstIcon);
export default __webpack_public_path__ + "static/media/first_icon.33f6fd396d308168e3c6c829a75a48f8.svg";
export { ForwardRef as ReactComponent };